// Navbar section

import { scrollEventThrottle } from '../utils';


document.addEventListener('DOMContentLoaded', function() {

    // Click of mobile menu links
    document.querySelectorAll('.nav-item a').forEach(function (navLink) {
        navLink.addEventListener('click', function () {
            document.getElementById('hamburger-toggle').checked = false;
        });
    });

    // Mark the navbar as scrolled
    scrollEventThrottle((scrollPos, previousScrollPos) => {
        var navContainer = document.querySelector('.nav-container');
        if (window.pageYOffset >= navContainer.getBoundingClientRect().height / 4) {
            navContainer.classList.add('scrolled');
        } else {
            navContainer.classList.remove('scrolled');
        }
    });
    window.dispatchEvent(new CustomEvent('scroll'));
});
